module.exports = __webpack_public_path__ + "media/images/undraw/reserve/add_information-aba2ba8f13cd2424e5d6cf2ea28c54ed.png";